import componentModel from 'decorators/componentModel';
import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import 'libraries/contentbox';
import tagsParser from '../../../../managers/tagsParser';
import './viewer.html';
import './viewer.scss';

interface ContentBoxViewerConfig {
    html: SubscribableOrNullableValue<string>
    footer: SubscribableOrNullableValue<string>
    height: SubscribableOrNullableValue<string>
}

export class ContentBoxViewer {
    html: Subscribable<string>
    footer: Subscribable<string | undefined>
    height: Subscribable<string>

    constructor(jsonModel: ContentBoxViewerConfig) {
        this.html = ko.flattenComputed(jsonModel.html, '');
        this.footer = ko.flattenComputed(jsonModel.footer);
        this.height = ko.flattenComputed(jsonModel.height, '100vh');
    }
}

@injectable()
@componentModel(ContentBoxViewer)
export default class ContentBoxViewerVM {
    wrapperNode = ko.observable<HTMLElement>();

    templateNodes: Array<Node>
    htmlNodes: Subscribable<Array<Node>>
    footerTemplateId: Subscribable<string | undefined>
    height: Subscribable<string>

    constructor(
        @inject(wccModules.componentConfig) private model: ContentBoxViewer,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.templateNodes = info.templateNodes;
        this.htmlNodes = ko.pureComputed(() => this.getHtmlNodes());
        this.footerTemplateId = model.footer;
        this.height = model.height;

        ko.applyBindingsToNode(info.element, {
            'css': {
                'content-box-viewer': true,
                'content-box-viewer--no-pace': true,
                'wcc-content-box': true
            },

            'widgetsContainer': true
        });

        if (info.templateNodes.length > 0)
            info.templateNodes.forEach(node => info.element.appendChild(node));
    }

    onRender = () => {
        this._updateScrollr();
    }

    private getHtmlNodes(): Array<Node> {
        const container = document.createElement('div');
        container.innerHTML = this.model.html();

        if (WCC?.Settings?.CurrentUser?.ParticipantTags?.length || 0 != 0) {
            container.innerHTML = tagsParser.processTags(container.innerHTML, WCC.Settings.CurrentUser.ParticipantTags);
        }

        return [...container.childNodes];
    }

    private _updateScrollr() {
        var s = skrollr.get();

        if (s != null)
            s.refresh();
    }
}